import { Text, Grid } from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import { api } from "../../services/api";
import { CityContext } from '../../Context/CityContext';
import { useLocation } from 'react-router-dom';
import { FilterChip } from "../FilterChip";

const brandOptions = [
  "Vanfall","A Equilibrista e Laut","Hoog Bier","Mutuca",
  "Austen Cervejaria","Laut","Beer Happy","A Equilibrista","Xangolião","Vinil",
];

export function ChoppFilters(props) {
  const location = useLocation();
  const [beerBrands, setBeerBrands] = useState([]);
  const { cityParam } = useContext(CityContext);

  async function filterProducts(brands) {
    let url = `/api/v1/products?city_id=${cityParam}`;
    if (brands.length > 0) {
      url += `&chopp_brands=${brands.join(',')}`;
    } else {
      const filter = new URLSearchParams(location.search).get("filter");
      if (filter) url += `&filter=${filter}`;
    }
    const response = await api.get(url);
    props.setProducts(response.data.products);
  }

  function toggleBrand(brand) {
    const updated = beerBrands.includes(brand) ? beerBrands.filter(b => b !== brand) : [...beerBrands, brand];
    setBeerBrands(updated);
    filterProducts(updated);
  }

  return (
    <>
      <Text fontSize="11px" fontWeight="800" color="rgba(0,74,51,0.55)" letterSpacing="0.08em" textTransform="uppercase" mb="10px">
        Marcas
      </Text>
      <Grid templateColumns="repeat(2,1fr)" gap="8px">
        {brandOptions.map((b, i) => (
          <FilterChip key={i} label={b} isActive={beerBrands.includes(b)} onClick={() => toggleBrand(b)} />
        ))}
      </Grid>
    </>
  );
}
